import FilterForm from '../../components/forms/FilterForm';
import { Col, Form, Input, Row, Space, Table } from 'antd';
import { CreateGraduateCourseModal } from 'components/modal/graduate_courses/CreateGraduateCourseModal';
import { EditButton, TextField, useTable } from '@refinedev/antd';
import { HttpError, useCan } from '@refinedev/core';
import { IGraduateCourse } from 'interfaces/graduate_courses';
import { ListLayout } from 'components/layout/layout/ListLayout';
import { SearchOutlined } from '@ant-design/icons';
import { formatDate } from 'services/date';
import { useState } from 'react';

interface IFilter {
  name: string;
  externalRef: string;
  code: string;
}

export const GraduateCourseList = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const canCreate = useCan({
    action: 'create',
    resource: 'graduate_courses'
  });

  const { tableProps, searchFormProps } = useTable<
    IGraduateCourse,
    HttpError,
    IFilter
  >({
    onSearch: params => {
      const { name, externalRef, code } = params;

      return [
        {
          field: 'filter[name]',
          operator: 'eq',
          value: name
        },
        {
          field: 'filter[by_code]',
          operator: 'eq',
          value: code
        },
        {
          field: 'filter[search_external_reference]',
          operator: 'eq',
          value: externalRef
        }
      ];
    },
    sorters: {
      mode: 'server'
    }
  });

  return (
    <ListLayout
      title="Cursos Regulados"
      createButtonProps={{
        hidden: !canCreate?.data?.can,
        onClick: () => setIsModalOpen(true)
      }}
    >
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <FilterForm searchFormProps={searchFormProps}>
            <Form.Item name="name">
              <Input
                placeholder="Buscar pelo nome do curso"
                className="min-w-[300px]"
                suffix={<SearchOutlined />}
              />
            </Form.Item>

            <Form.Item name="code">
              <Input placeholder="Código do curso" />
            </Form.Item>

            <Form.Item name="externalRef">
              <Input placeholder="Código externo do curso" />
            </Form.Item>
          </FilterForm>

          <Table {...tableProps} rowKey="id">
            <Table.Column
              dataIndex="name"
              key="name"
              title="Nome do curso"
              sorter
              fixed="left"
              render={value => <TextField value={value} />}
            />
            <Table.Column
              dataIndex="kind"
              key="kind"
              title="Tipo"
              sorter
              render={value => (
                <TextField
                  value={value === 'graduate' ? 'Pós Graduação' : 'Graduação'}
                />
              )}
            />
            <Table.Column
              dataIndex="duration_in_hours"
              key="duration_in_hours"
              title="Duração (h)"
              sorter
              render={value => <TextField value={value} />}
            />
            <Table.Column
              dataIndex="code"
              key="code"
              title="Código do curso"
              sorter
              render={value => <TextField value={value} />}
            />
            <Table.Column
              dataIndex="emec"
              key="emec"
              title="Código e-MEC"
              render={value => <TextField value={value ?? '-'} />}
            />
            <Table.Column
              dataIndex="external_reference"
              key="external_reference"
              title="Código externo"
              render={value => <TextField value={value ?? '-'} />}
            />
            <Table.Column
              dataIndex="created_at"
              key="created_at"
              title="Criado em"
              sorter
              render={value => (
                <TextField value={formatDate(value, 'DD/MM/YYYY')} />
              )}
            />
            <Table.Column
              dataIndex="updated_at"
              key="updated_at"
              title="Atualizado em"
              sorter
              render={value => (
                <TextField value={formatDate(value, 'DD/MM/YYYY')} />
              )}
            />
            <Table.Column<IGraduateCourse>
              title="Ações"
              dataIndex="actions"
              align="center"
              width={100}
              render={(_, record) => {
                return (
                  <Space>
                    <EditButton
                      hideText
                      size="small"
                      recordItemId={record.id}
                      accessControl={{ hideIfUnauthorized: true }}
                    />
                  </Space>
                );
              }}
            />
          </Table>
        </Col>
      </Row>

      {isModalOpen && canCreate?.data?.can && (
        <CreateGraduateCourseModal
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </ListLayout>
  );
};
